<section class="overflow-hidden">
    <div class="row d-flex justify-content-center row h-40">
        <div class="col align-items-center col d-flex justify-content-center">
            <button class="btn btn-primary p-2" (click)="exportXLSX(0)">Export Accounts </button>
        </div>
    </div>
</section>